<template>
    <div class="bg-white overflow-hidden shadow rounded-lg divide-y divide-gray-200">
        <div class="-ml-4 -mt-2 flex items-center justify-between flex-wrap sm:flex-nowrap px-4 py-5 sm:p-6">
            <div class="ml-4 mt-2">
                <h3 class="text-lg leading-6 font-medium text-gray-900">Images</h3>
            </div>
        </div>

        <div class="px-4 py-5 sm:p-6">
            <div class="mb-8">
                <AssetImageUpload
                    v-if="asset_id"
                    :asset_id="asset_id"
                    field_id="asset-images-uploader"
                    asset_type="general"
                    media_types="['image']"
                    :base_file_name="'image'"
                />
            </div>
            <AssetImageManager  :asset_id="asset_id" asset_type="general" :media_types="['image']" />
        </div>

        <div class="px-4 py-4 sm:px-6 text-right">
            <Button type="button" width="w-auto" color="blue-outline" :onClick="ASSET_STORE.activatePrevStep">Back</Button>
            <Button type="button" width="w-auto" class="ml-2" :onClick="() => submitStep()" :disabled="!next_button_active">Next</Button>
        </div>

    </div>
</template>

<script>
import { useAssetStore } from '@sto/asset.store'
import { useSystemStore } from '@sto/system.store'
import { useAuthStore } from '@sto/auth.store'

import { computed, onMounted, onBeforeMount, reactive, watch, ref } from 'vue'
import { isValid, getPayload, getUserOrganisationType } from '@lib/helpers'
import { useRoute } from 'vue-router'
import config from '@/config'

import LoadingIcon from '@ico/LoadingIcon.vue'
import AssetImageUpload from '@par/asset/AssetImageUpload.vue'
import AssetImageManager from '@par/asset/AssetImageManager.vue'
import AssetImageManagerCompact from "@par/asset/AssetImageManagerCompact.vue";
export default {
    components: {
        AssetImageManagerCompact,
        LoadingIcon,
        AssetImageUpload,
        AssetImageManager
    },
    setup() {
        const ROUTE = useRoute()
        const ASSET_STORE = useAssetStore()
        const SYSTEM_STORE = useSystemStore()
        const AUTH_STORE = useAuthStore()

        const asset_id = computed(() => {
            return ASSET_STORE?.asset?.id || null
        })

        const asset_data = computed(() => {
            return ASSET_STORE?.asset || null
        })

        const next_button_active = computed(() => {

            let active = true

            for (let f in state.asset_form.fields) {
                if (state.asset_form.fields[f].required && !state.asset_form.fields[f].value) active = false
            }

            return active
        })

        const state = reactive({
            asset_form: {
                show_fields: false,
                valid: false,
                has_changes: computed(() => {
                    let has_changes = false
                    for (let f in state.asset_form.fields) {
                        if (state.asset_form.fields[f].value != state.asset_form.fields[f].stored_value) has_changes = true
                    }
                    return has_changes
                }),
                loading: false,
                fields: {
                    vrm: {
                        active: true,
                        label: 'VRM',
                        type: 'text',
                        value: '',
                        stored_value: '',
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: false
                    }
                }
            },
        })

        const setAssetData = asset => {
            if (!asset) return

            for (let field in state.asset_form.fields) {
                if (asset[field]) {
                    state.asset_form.fields[field].value = asset[field]
                    state.asset_form.fields[field].disabled = !state.asset_form.fields[field].editable
                }
                state.asset_form.fields[field].pristine = false
            }
        }

        const submitStep = async () => {
            // fields will automatically create their own validation states
            if (state.asset_form.loading || !isValid(state.asset_form.fields)) return

            // if the value is present and unchaned, just skip to the next step
            if (!state.asset_form.has_changes) {
                ASSET_STORE.activateNextStep()
                return
            }

            state.asset_form.loading = true

            try {

                const asset_payload = getPayload(state.asset_form.fields)
                await ASSET_STORE.update(ASSET_STORE.asset.id, asset_payload)
                ASSET_STORE.activateNextStep()

            } catch (error) {
                console.error('submitStep', error)
                // TODO handle error
            }

            state.asset_form.loading = false
        }


        watch(
            () => asset_data.value,
            (new_value, old_value) => {
                setAssetData(asset_data.value)
            }
        )

        onMounted(() => {

        })

        return {
            ASSET_STORE,
            state,
            next_button_active,
            asset_id,
            submitStep
        }
    }
}
</script>

